import React from 'react';
import {useTranslation} from 'react-i18next';
import {IValidationErrorObject} from '../../../../../incase-domain/common/validationErrorResponse';
import {IQuestionElements} from '../../../../../incase-domain/elements/question';
import {MAX_QUESTION_LENGTH} from '../../../../../incase-domain/validators/elements/constant';
import {questionBaseValidator} from '../../../../../incase-domain/validators/elements/questionBase';
import {getErrorClasses} from '../../../../../utils/validation';
import SectionTitle from '../../../../elements/common/SectionTitle';
import DebouncedTextInput from '../../common/debounced/DebouncedTextInput';
import DebatableOption from './DebatableOption';

interface QuestionTextProps {
    highlightedElement: IQuestionElements;
    errors: IValidationErrorObject | null;
    highlightedElementChangeHandler: {
        single: (field: keyof IQuestionElements, value: unknown) => void;
        multiple: (fields: (keyof IQuestionElements)[], values: unknown[]) => void;
    };
    showDebatable?: boolean;
}

export default function QuestionText(props: QuestionTextProps): JSX.Element {
    const {highlightedElement, errors, highlightedElementChangeHandler, showDebatable} = props;
    const {t} = useTranslation();

    return (
        <div className="l-group--form">
            <div className={`l-group__item ${getErrorClasses(errors, 'question')}`}>
                <SectionTitle label={t('designSidepanel.question')} />
                <DebouncedTextInput
                    maxLength={MAX_QUESTION_LENGTH}
                    className="c-sidepanel__input"
                    onChange={(value) => highlightedElementChangeHandler.single('question', value)}
                    validator={(val) => {
                        const validation = questionBaseValidator.shape.question.safeParse(val);
                        return validation.success;
                    }}
                    value={highlightedElement.question}
                    placeholder={t('designSidepanel.enterQuestion')}
                />
            </div>

            {showDebatable && (
                <DebatableOption
                    highlightedElement={highlightedElement}
                    highlightedElementChangeHandler={highlightedElementChangeHandler}
                />
            )}
        </div>
    );
}
